module.exports = __webpack_public_path__ + "img/warn.712edd45.svg";